export default __webpack_public_path__ + "add_button_mobile.webp";